<template>
    <v-app>
        <v-navigation-drawer v-model="drawer" app permanent>
            <!-- Logo Section -->
            <div class="logo-container">
                <h1 class="text-center">OSCE</h1>
            </div>

            <v-divider></v-divider>

            <!-- Menu Items -->
            <v-list dense nav>
                <v-list-item v-for="item in menuItems" :key="item.title" link :to="item.route">
                    <v-list-item-icon class="listItemIcon">
                        <v-icon class="listIcon">{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content class="listContent">
                        <v-list-item-title class="listTitle">{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Logout Button at Bottom -->
                <v-list-item class="logout-btn" @click="logout">
                    <v-list-item-icon class="listItemIcon">
                        <v-icon class="listIcon">mdi-logout</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content class="listContent">
                        <v-list-item-title class="listTitle">登出</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>


        <v-main>
            <div class="d-flex justify-start align-start outliner">
                <router-view></router-view>
            </div>
            <v-dialog v-model="dialog" max-width="1000px" rounded="lg" persistent>
                <v-card class="pa-6">
                    <div class="d-flex align-start">
                        <!-- Title Section -->
                        <div class="flex-grow-1">
                            <v-card-title class="text-h5 mb-4 text-left">
                                歡迎來到 OSCE
                                <br />
                                請設定帳號基本資料
                            </v-card-title>
                        </div>

                        <!-- Avatar Upload Section -->
                        <div class="avatar-upload" v-if="false">
                            <input type="file" ref="fileInput" accept="image/*" @change="onFileSelected" class="d-none" >
                            <v-avatar size="100" class="avatar-preview" @click="$refs.fileInput.click()">
                                <v-img v-if="avatarPreview" :src="avatarPreview" alt="Avatar"></v-img>
                                <v-icon v-else size="40" color="grey">
                                    mdi-account
                                </v-icon>
                            </v-avatar>
                        </div>
                    </div>

                    <v-card-text style="padding-top: 4rem;">
                        <v-form>
                <v-row>
                    <!-- 姓名 -->
                    <v-col cols="12" md="4">
                        <v-text-field v-model="profile.name" label="姓名" outlined ></v-text-field>
                    </v-col>
                    <!-- 電話 -->
                    <v-col cols="12" md="4">
                        <v-text-field v-model="profile.phone" label="電話" outlined ></v-text-field>
                    </v-col>
                    <!-- 信箱 -->
                    <v-col cols="12" md="4">
                        <v-text-field v-model="profile.email" label="信箱" outlined ></v-text-field>
                    </v-col>
                    <!-- 學校名稱 -->
                    <v-col cols="12" md="4">
                        <v-text-field v-model="profile.school.name" label="學校名稱" outlined  :readonly="true"></v-text-field>
                    </v-col>
                    <!-- 系所名稱 -->
                    <v-col cols="12" md="4">
                        <v-text-field v-model="profile.department.name" label="系所名稱" outlined  :readonly="true"></v-text-field>
                    </v-col>
                    <!-- 性別 -->
                    <v-col cols="12" md="4">
                        <v-select v-model="profile.sex" :items="sexOptions" label="性別" outlined ></v-select>
                    </v-col>

                    <!-- 帳號 -->
                    <v-col cols="12" md="4">
                        <v-text-field v-model="profile.username" label="帳號" outlined ></v-text-field>
                    </v-col>
                    <!-- 密碼 -->
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="profile.password"
                            label="密碼"
                            :type="showPassword ? 'text' : 'password'"
                            outlined
                            :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                            @click:append="showPassword = !showPassword"
                        ></v-text-field>
                    </v-col>

                </v-row>
            </v-form>
                    </v-card-text>

                    <v-card-actions class="pt-6">
                        <v-spacer></v-spacer>
                        <v-btn color="black" dark height="44" @click="submitForm"
                            style="border-radius: 10px;width: 15rem;">
                            完成
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-main>
    </v-app>
</template>

<script>
import AuthService from '../services/auth.service'
import userService from '@/services/user.service'
export default {
    name: 'StudentView',
    data() {
        return {
            drawer: true,
            menuItems: [{
                title: '個人資料',
                icon: 'mdi-account',
                route: '/teacher/profile'
            },
            {
                title: '學生管理',
                icon: 'mdi-school',
                route: '/teacher/management'
            },
            {
                title: '群組管理',
                icon: 'mdi-account-group',
                route: '/teacher/groups'
            },
            {
                title: '病例標籤管理',
                icon: 'mdi-file-document',
                route: '/teacher/caseTags'
            },
            {
                title: '虛擬病患管理',
                icon: 'mdi-hospital',
                route: '/teacher/patients'
            },
            {
                title: '測驗管理',
                icon: 'mdi-clipboard-text',
                route: '/teacher/tests'
            },
            {
                title: '回報管理',
                icon: 'mdi-message-reply',
                route: '/teacher/reports'
            },
            ],
            dialog: false,
            profile: {
                name: '',
                phone: '',
                email: '',
                username: '',
                password: '',
                school: {
                    name: '',
                    contactPerson: '',
                },
                department: {
                    name: '',
                },
                avatarUrl: null // 頭像URL
            },
            showPassword: false,
            sexOptions:['男','女','其他'],
            avatarPreview: null,
        }
    },
    methods: {
        init() {
            if (localStorage.getItem("authenticated")) {
                AuthService.verifyToken()
                    .then(() => {
                    })
                    .catch(() => {
                        localStorage.removeItem("authenticated")
                        this.$router.push('/')
                    })
            }else{
                this.$router.push('/')
            }
            userService.getUserInfo(localStorage.getItem('user_id')).then((res) => {
                this.profile = res.data
                if (res.data.userType !== undefined) {
                        if (res.data.userType == 0) {
                            this.$router.push("/admin");
                   
                        } else if (res.data.userType == 1) {
                            this.$router.push("/school");
                        
                        }  else if (res.data.userType == 3) {
                            this.$router.push("/student");
                        }
                    }

                if(!this.profile.editedProfile){
                    this.dialog = true
                }
            })
            .catch((err) => {
                console.log(err);
                localStorage.removeItem("authenticated")
                this.$router.push('/')
            })
        },
        logout() {
            // 處理登出邏輯
            AuthService.logout()
                .then(() => {
                    console.log("logout")
                    this.$router.push('/')
                })
                .catch(err => {
                    console.log(err)
                    alert(err.message) 
                })
        },
        submitForm() {
            if(this.profile.password === ''){
                return alert('密碼不能為空')
            }   
            if(this.profile.name === ''){
                return alert('姓名不能為空')
            }
            if(this.profile.phone === ''){
                return alert('電話不能為空')
            }
            if(this.profile.email === ''){
                return alert('信箱不能為空')
            }   
            if(this.profile.username === ''){
                return alert('帳號不能為空')
            }
            if(this.profile.school === null){
                return alert('學校名稱不能為空')
            }
            this.profile.editedProfile = true
            userService.updateUserInfo(localStorage.getItem('user_id'), this.profile).then(() => {
                this.init()
                this.dialog = false
            })
        },
        checkUserType() {
            if (localStorage.getItem('userType') != 2) {
                return window.location.reload()
            }else{
                return
            }
        },
    },
    mounted() {
        this.init()
        window.addEventListener("focus", this.checkUserType);
        document.addEventListener("visibilitychange", this.checkUserType);
    },
    beforeDestroy() {
        window.removeEventListener("focus", this.checkUserType);
        document.removeEventListener("visibilitychange", this.checkUserType);
    }
}
</script>

<style scoped>
.v-navigation-drawer {
    background-color: #f5f5f5;
    width: 300px !important;
}

.logo-container {
    padding: 30px;
    background-color: #000;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
}

.logo-container h1 {
    font-size: 24px;
}

.v-list {
    padding: 20px 10px 20px 10px;
}

.v-list-item {
    margin: 12px 0;
    height: 56px !important;
    border-radius: 8px;
}

.listItemIcon {
    align-self: center;
    margin-left: 12px;
}

.listIcon {
    font-size: 1.8rem !important;
}

.v-icon {
    font-size: 1.2rempx !important;
}

.listTitle {
    font-size: 1.2rem !important;
    line-height: 1.2rem !important;
    text-align: left;
    font-weight: 500;
}

.logout-btn {
    position: fixed;
    bottom: 0;
    padding: 20px 10px 20px 10px;
    border-top: 1px solid #e0e0e0;
    height: 64px !important;
    align-self: center;
    background-color: #f5f5f5;
}

.v-main {
    margin-left: 300px !important;
}

.v-list-item:hover {
    background-color: #e0e0e0;
}

.v-card {
    border-radius: 30px;
}

.v-card-title {
    display: block;
    padding: 0;
}

.avatar-upload {
    margin-left: 16px;
}

.avatar-preview {
    cursor: pointer;
    border: 2px dashed #e0e0e0;
    background-color: #f5f5f5;
    transition: all 0.3s;
}

.avatar-preview:hover {
    border-color: #000;
    opacity: 0.8;
}

.v-main {
    padding: 0 !important;
}

.outliner {
    border: 2px solid #000;
    padding: 30px;
    margin: 50px;
    margin-bottom: 150px;
    height: 90%;

}
</style>